import { render, staticRenderFns } from "./VehicleCreateModal.vue?vue&type=template&id=40510656&scoped=true"
import script from "./VehicleCreateModal.vue?vue&type=script&lang=js"
export * from "./VehicleCreateModal.vue?vue&type=script&lang=js"
import style0 from "./VehicleCreateModal.vue?vue&type=style&index=0&id=40510656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40510656",
  null
  
)

export default component.exports